import { StatementDetailsAPIParameter, StatementDetailsModel, getStatementDetail } from "@NA/Services/ADIViewMyStatementsService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<StatementDetailsAPIParameter & HasOnSuccess & HasOnError, StatementDetailsModel>;

export const getAllStatementDetails: HandlerType = async (props: any) => {
    props.result = await getStatementDetail({
        statementNo: props.parameter.statementNo
    });
    if (props.result.successful) {
        props.parameter.onSuccess(props.result.result);
    } else {
        props.parameter.onError(props.result);
    }
    if (!props.result) {
        return false;
    }
};

export const chain = [getAllStatementDetails];

const adiStatementDetailsHandler = createHandlerChainRunner(chain, "ADIStatementDetailsHandler");
export default adiStatementDetailsHandler;
